const isSEOPage = (pathname: string): boolean => {
  try {
    const _pathname = decodeURIComponent(pathname.toLowerCase().replace(/\s/g, '-').replace(/%20/g, '-'))

    const regex = [
      /^\/(perfumes|colognes|fragrance|brands)$/,           //  /perfumes*, ...
      /^\/(.+-)?(perfume|cologne|fragrance)s?-for-.+$/,     //  /perfume-for-, /perfumes-for-, /*-perfume-for-, /*-perfumes-for-, ...
      /^\/.+-(perfume|cologne|fragrance)s?$/,               //  /*-perfume, /*-perfumes, ...
      /^\/na-(perfume|cologne)s(\/.*)?$/,                   //  /na-perfume, /na-perfumes, /na-perfume/*, /na-perfumes/*, ...
    ]

    return regex.some((regex) => regex.test(_pathname))
  }
  catch (error) {
    // decodeURIComponent will throw error 'URI malformed' for urls like /servlet/%C0%AE%C0%AE%C0%AF
    // catch needed to show 404 error instead of 500 error page
    return false
  }
}


export default isSEOPage
